import React from 'react'
import Fragment from '../common/fragment'


function FragmentDH(props) {
  return (
    <Fragment pos="hhhh" {...props}>
      <p className="interact interactive" id="anchor-zoom-d">
Salamanca: agonía humeante y autómatas.
      </p>
    </Fragment>
  )
}


export default FragmentDH
